import { handleActions } from "redux-actions";

export default handleActions(
  {
    COMPANY_ASSETS_PUBLIC_GET: {
      FULFILLED: (state, action) => ({
        companyAssets: [...state.companyAssets, ...action.payload.assets],
      }),
    },
  },
  {},
  { namespace: "_" }
);
